module.exports = __webpack_public_path__ + "static/media/Charla Lucas Headshot.6e7bc28c.png";